// 
import WebComponent from '../webComponents/WebComponent';
import print from 'print-js';

export default class PrintPdf extends WebComponent {
  didMount() {
    this.on('click', (e) => {
      e.preventDefault();
      print(this.element.href);
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/PrintPdf.js